<!--<div class="row">-->
<!--  <div class="col-md-12 text-sm-center">-->
<!--    <p class="h3">Administrar Productos</p>-->
<!--  </div>-->
<!--</div>-->
<div class="row">
  <div class="col-md-12 col-sm-12">
    <app-product-list></app-product-list>
  </div>
</div>
